import React from 'react';

import { DateRangeFormatter, NumberValueFormatter } from '@gogame/intl-ts';

const AdditionalSpendFee = ({ period, taxFeePercent }) => {
  return (
    <React.Fragment>
      {taxFeePercent !== undefined && (
        <NumberValueFormatter.Percent value={taxFeePercent} />
      )}
      {' ('}
      {period !== undefined && (
        <DateRangeFormatter value={[period.from, period.to]} template={'LL'} />
      )}
      {/* eslint-disable-next-line */}
      {')'}
    </React.Fragment>
  );
};

export default AdditionalSpendFee;
